// extracted by mini-css-extract-plugin
module.exports = {"Scanner":"Scanner_Scanner__2gu1v","User":"Scanner_User__1tKtd"};